import "./App.css";

import { NavBar } from "./components/NavBar";
import { Home } from "./routes/Home";
import { Photography } from "./routes/Photography";
// import { Projects } from "./routes/Projects";
// import { Contact } from "./routes/Contact";
import { Route, Routes, HashRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function App() {
  return (
    <HashRouter>
      <div className="App">
        <NavBar />
        <Routes>
          <Route index element={<Home />} />
          <Route path="/home" element={<Home />}></Route>
          {/* <Route path="/photography" element={<Photography />}></Route> */}
        </Routes>
      </div>
    </HashRouter>
  );
}